import {
  TASK_DELETE,
  TASK_DELETE_CLOSE,
  TASK_EDIT,
  TASK_EDIT_CLOSE,
} from '../pages/Tasks/TaskConstants';

const taskState = {
  edit: false,
  delete: false,
  rowId: null,
};

export default (state = taskState, event) => {
  switch (event.type) {
    case TASK_EDIT:
      return {
        ...state,
        edit: true,
        rowId: event.data.rowId,
      };
    case TASK_EDIT_CLOSE: {
      return {
        ...state,
        edit: false,
        rowId: null,
      };
    }
    case TASK_DELETE:
      return {
        ...state,
        delete: true,
        rowId: event.data.rowId,
      };
    case TASK_DELETE_CLOSE:
      return {
        ...state,
        delete: false,
        rowId: null,
      };

    default:
      return state;
  }
};
